import React from 'react';
import styles from './WarrantyAboutSection.module.scss';

const AboutSection = ({ aboutSectionData }) => {
  // 处理Sitecore格式的富文本数据
  const textDescription = aboutSectionData?.textDescription || '';

  // 处理按钮数据
  const button = aboutSectionData?.button || {};

  return (
    <div className={styles.warrantyContainer} data-aos="fade-up">
      <div className={styles.warrantyInfoContainer}>
        <div className={styles.warrantyInfo}>
          <div className={styles.textSection}>
            <div dangerouslySetInnerHTML={{ __html: textDescription }} />
          </div>

          {button?.buttonUrl && (
            <a
              href={button.buttonUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.button}
            >
              {button.buttonText}
            </a>
          )}
        </div>
      </div>
      <div className={styles.warrantyDetails}>
        <div className={styles.warrantyItemContainer}>
          <div className={styles.warrantyItem}>
            <h1 className={styles.value}>
              {aboutSectionData?.durationValue}
              <span>{aboutSectionData?.aboutDurationUnit}</span>
            </h1>
          </div>
        </div>
        <div className={styles.warrantyItemContainer}>
          <div className={styles.warrantyItem}>
            <h1>
              {aboutSectionData?.mileageValue}
              <span>{aboutSectionData?.aboutMileageUnit}</span>
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
